import { WidgetActionMethod } from '../../WidgetVariant';

enum FloatingActionButtonActionMethod {
  Hide = 'hide',
  Show = 'show',
  InitiateSimplrChat = 'initiateSimplrChat',
}

export type ActionMethod = FloatingActionButtonActionMethod | WidgetActionMethod;

export const ActionMethod = {
  ...FloatingActionButtonActionMethod,
  ...WidgetActionMethod,
};
